export function AccountService(accountHost, callbackPath, { forceCurrentOrigin } = {}) {
  const currentOrigin = forceCurrentOrigin || window.location.origin;
  const redirectTo = `${currentOrigin}${callbackPath}`
  return {
    /**
     * @param {{ from?: string, force?: boolean }=} opts
     */
    generateUrlToLoginPage({ from, force } = {}) {
      const stateString = serializeState({ from });
      return `${accountHost}/login?state=${stateString}&redirectTo=${redirectTo}&force=${force ? '1' : ''}`;
    },
    /**
     * @param {{ from?: string, redirectAfterLogout?: boolean, redirectTo?: string }=} opts
     */
    generateUrlToLogoutPage({ from, redirectAfterLogout, redirectTo: forceRedirectTo } = {}) {
      const stateString = serializeState({ from });
      if (redirectAfterLogout) {
        return `${accountHost}/logout?redirectAfterLogout&redirectTo=${forceRedirectTo || currentOrigin}`;
      } else {
        return `${accountHost}/logout?state=${stateString}&redirectTo=${redirectTo}`;
      }
    },
    /**
     * @param {URLSearchParams} params
     */
    parseCallbackParams(params) {
      const token = params.get("token");
      const expiresAt = params.get("expiresAt");
      const state = parseState(params.get("state"));

      return {
        token,
        expiresAt,
        from: state.from,
      };
    },
  };
}

/**
 * @param {string | null} value
 * @returns {Record<string, string>}
 */
function parseState(value) {
  if (!value) return {};
  try {
    const decoded = atob(value);
    return JSON.parse(decoded);
  } catch (e) {
    return {};
  }
}

/**
 * @param {Record<string, string>} state
 */
function serializeState (state) {
  return btoa(JSON.stringify(state));
}
